// Tablet and phone chrome for the page editor (below 1024px; CSS hides both
// above): the bottom bar that opens the rail drawer or the settings sheet, and
// the floating "Edit hero" pill that opens the sheet for the selected section.
import { LayersIcon, PaintbrushIcon, SparklesIcon, SquarePenIcon } from '../icons';

export function PhoneBottomBar({ onSections, onDesign, onAi }: {
  onSections: () => void;
  onDesign: () => void;
  onAi: () => void;
}) {
  return (
    <nav className="pe-mobile-bar" aria-label="Editor panels">
      <button type="button" onClick={onSections}><LayersIcon size={16} />Sections</button>
      <button type="button" onClick={onDesign}><PaintbrushIcon size={16} />Design</button>
      <button type="button" onClick={onAi}><SparklesIcon size={16} />AI</button>
    </nav>
  );
}

/** "Edit hero": opens the settings sheet on the selected section. */
export function PhoneEditPill({ label, onClick }: { label: string; onClick: () => void }) {
  return (
    <button type="button" className="pe-edit-pill" onClick={onClick}>
      <SquarePenIcon size={15} />{label}
    </button>
  );
}
